/** Staff-only, bounded diagnostics. Never retain bodies, headers or error prose. */
export interface RequestDiagnostic { kind: string; method: string; path: string; status: number; request_id?: string }
let owner: string | null = null
let generation = 0
let failures: RequestDiagnostic[] = []
const routeWords = new Set('api mocktest admin tests test-runs results students employees employee admins questions question-groups groups sections parts submissions review-queue dashboard analytics overview reports summary list detail fetch create update delete add save publish unpublish archived restore progress submit complete abandon search announcements activity recommendations fetch_artifacts calculators overall-band raw-band'.split(' '))
export function setDiagnosticOwner(value: string | null) {
  if (owner !== value) { failures = []; generation += 1 }
  owner = value
}
export function safeRequestPath(value: string): string | null {
  const path = value.split(/[?#]/)[0]
  if (!/^\/(?:api|mocktest)\/[a-zA-Z0-9/_-]{1,180}$/.test(path)
    || /(?:auth|token|password|magiclink|activate|media|attachments|staff-tickets)/i.test(path)) return null
  return path.split('/').map((segment) => !segment || routeWords.has(segment) ? segment : 'id').join('/')
}
export function recordRequestFailure(value: RequestDiagnostic) {
  const path = safeRequestPath(value.path)
  if (!owner || !path) return
  failures = [...failures, { kind: value.kind === 'unavailable' ? 'http' : value.kind === 'invalid-response' ? 'client' : ['http', 'network', 'timeout'].includes(value.kind) ? value.kind : 'network',
    method: /^(GET|POST|PUT|PATCH|DELETE|HEAD)$/.test(value.method) ? value.method : 'GET', path,
    status: Number.isInteger(value.status) && value.status >= 0 && value.status <= 599 ? value.status : 0,
    ...(value.request_id && /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(value.request_id) ? { request_id: value.request_id } : {}) }].slice(-10)
}
export function recentRequestFailures() { return failures.map((row) => ({ ...row })) }

/** A request started under another account must not enter the next session. */
export function requestFailureRecorder() {
  const startedOwner = owner
  const startedGeneration = generation
  return (value: RequestDiagnostic) => { if (startedOwner && startedOwner === owner && startedGeneration === generation) recordRequestFailure(value) }
}
